import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions, DynamicInvoicePageActionTypes } from "./dynamic-invoice-page-store";
function* getDynamicInvoices() {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.getPreparedInvoicesForApprovalAsync);
    if (apiResult.ok) {
        yield* put(actions.getDynamicInvoicesSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getDynamicInvoicesFail(apiResult.error));
    }
}
function* watchGetDynamicInvoicesRequest() {
    yield* takeEvery(DynamicInvoicePageActionTypes.GetDynamicInvoicesRequest, getDynamicInvoices);
}
function* approvePreparedInvoices(action) {
    const succededIds = [];
    const errors = [];
    for (const preparedInvoiceId of action.payload.preparedInvoiceIds) {
        const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.approvePreparedInvoiceAsync, preparedInvoiceId);
        if (apiResult.ok) {
            succededIds.push(preparedInvoiceId);
        }
        else {
            errors.push(apiResult.error);
            break;
        }
    }
    if (succededIds.length === action.payload.preparedInvoiceIds.length) {
        yield* put(actions.approvePreparedInvoicesSuccess(action.payload.preparedInvoiceIds));
    }
    else {
        yield* put(actions.approvePreparedInvoicesFail(errors.join(" "), succededIds));
    }
}
function* watchApprovePreparedInvoicesRequest() {
    yield* takeEvery(DynamicInvoicePageActionTypes.ApprovePreparedInvoicesRequest, approvePreparedInvoices);
}
function* rejectPreparedInvoice(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.rejectPreparedInvoiceAsync, action.payload.preparedInvoiceId, action.payload.rejectReason);
    if (apiResult.ok) {
        yield* put(actions.rejectPreparedInvoiceSuccess(action.payload.preparedInvoiceId));
        yield* put(actions.hideRejectDialog());
        yield* put(actions.hideDynamicInvoiceDialog());
    }
    else {
        yield* put(actions.rejectPreparedInvoiceFail(apiResult.error));
    }
}
function* watchRejectPreparedInvoiceRequest() {
    yield* takeEvery(DynamicInvoicePageActionTypes.RejectPreparedInvoiceRequest, rejectPreparedInvoice);
}
function* forwardPreparedInvoice(action) {
    const succededIds = [];
    const errors = [];
    for (const preparedInvoiceId of action.payload.preparedInvoiceIds) {
        const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.forwardPreparedInvoiceAsync, preparedInvoiceId, action.payload.forwardReason);
        if (apiResult.ok) {
            succededIds.push(preparedInvoiceId);
        }
        else {
            errors.push(apiResult.error);
            break;
        }
    }
    if (succededIds.length === action.payload.preparedInvoiceIds.length) {
        yield* put(actions.forwardPreparedInvoiceSuccess(action.payload.preparedInvoiceIds));
        yield* put(actions.hideForwardDialog());
        yield* put(actions.hideDynamicInvoiceDialog());
    }
    else {
        yield* put(actions.forwardPreparedInvoiceFail(errors.join(" "), succededIds));
    }
}
function* watchForwardPreparedInvoiceRequest() {
    yield* takeEvery(DynamicInvoicePageActionTypes.ForwardPreparedInvoiceRequest, forwardPreparedInvoice);
}
function* deletePreparedInvoices(action) {
    const succededIds = [];
    const errors = [];
    for (const preparedInvoiceId of action.payload.preparedInvoiceIds) {
        const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.deletePreparedInvoiceAsync, preparedInvoiceId);
        if (apiResult.ok) {
            succededIds.push(preparedInvoiceId);
        }
        else {
            errors.push(apiResult.error);
            break;
        }
    }
    if (succededIds.length === action.payload.preparedInvoiceIds.length) {
        yield* put(actions.deletePreparedInvoicesSuccess(action.payload.preparedInvoiceIds));
    }
    else {
        yield* put(actions.deletePreparedInvoicesFail(errors.join(" "), succededIds));
    }
}
function* watchDeletePreparedInvoicesRequest() {
    yield* takeEvery(DynamicInvoicePageActionTypes.DeletePreparedInvoicesRequest, deletePreparedInvoices);
}
export const dynamicInvoicesPageSagaInit = () => [
    fork(watchApprovePreparedInvoicesRequest),
    fork(watchForwardPreparedInvoiceRequest),
    fork(watchGetDynamicInvoicesRequest),
    fork(watchRejectPreparedInvoiceRequest),
    fork(watchDeletePreparedInvoicesRequest)
];
